import { createFileRoute } from "@tanstack/react-router";
// import { useMemo } from "react";
import {
  ActiveList,
  PiiBoard,
  // PostureStrip, // still on the design model - back once its API lands
  RiskTools,
} from "./-dashboard/-components";
import { ExposureFlow, LeakMap, ThreatBubbles } from "./-dashboard/charts";
// import { activeSet } from "./-dashboard/-state";

export const Route = createFileRoute("/_app/")({
  component: RouteComponent,
});

function RouteComponent() {
  // the panels still on the design model read the whole window
  // const active = useMemo(() => activeSet(), []);

  return (
    <div className="w-full p-6">
      <div className="flex flex-col gap-3.5">
        {/* <PostureStrip active={active} /> */}

        <ExposureFlow />

        <div className="flex items-baseline gap-3.5 px-0.5 pt-4">
          <h2 className="text-xl font-extrabold tracking-tight">
            Threat &amp; exposure
          </h2>
          <p className="m-0 max-w-[62ch] text-xs text-muted-foreground">
            Volume, risk and where organizational data is actually landing —
            read across the people, the apps and sites they work in, and the AI
            endpoints they reach.
          </p>
          <span className="h-px min-w-5 flex-1 bg-border" />
        </div>

        <div className="grid grid-cols-1 gap-3.5 lg:grid-cols-3">
          <ThreatBubbles />
          <LeakMap />
          <PiiBoard />
          <RiskTools />
          <ActiveList />
        </div>
      </div>
    </div>
  );
}
